import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { ApiErrorHandlerService } from '@bds/helpers';
import { EquipComponentDate } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class EquipComponentDatesService {
    controllerName = 'EquipComponentDates';

    constructor(
        private http: HttpClient,
        @Inject('BASE_API_URL') private apibaseUrl: string,
        @Inject('BASE_ODATA_URL') private odatabaseUrl: string,
        private apiErrorHandler: ApiErrorHandlerService,
    ) {}

    getFiltered(
        equipComponentId: number,
        equipmentId: number,
        mechField: string,
    ): Observable<EquipComponentDate[]> {
        let filterUrl = '';

        if (equipComponentId && equipmentId) {
            filterUrl = `?$filter=(equipmentComponentOrmId eq ${equipComponentId}) and (equipmentOrmId eq ${equipmentId}) and (mechField eq '${mechField}')`;

            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return (
                this.http
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .get<any>(`${this.odatabaseUrl}${this.controllerName}${filterUrl}`)
                    .pipe(
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
                        map((data) => data.value),
                        shareReplay(),
                        catchError((err) => this.apiErrorHandler.handleError(err)),
                    )
            );
        } else {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return of(null);
        }
    }

    updateEquipComponentFieldDates(
        equipmentComponentId: number,
        mechField: string,
        equipDates: EquipComponentDate[],
    ): Observable<EquipComponentDate[]> {
        return this.http
            .put<EquipComponentDate[]>(
                `${this.apibaseUrl}${this.controllerName}/${equipmentComponentId}/${mechField}`,
                equipDates,
            )
            .pipe(
                map((data: EquipComponentDate[]) => {
                    return data ? data : null;
                }),
                catchError((err) => this.apiErrorHandler.handleError(err)),
            );
    }
}
